import { AccessContext } from "./types";

interface BuildInput {
  host: string;
  params: { rules?: string; url?: string };
}

// Monta o AccessContext normalizado. urlHost = hostname de ?url; parse falho → undefined.
// Fonte única lida por resolveBrand e pelo travamento de fluxo por domínio.
export function buildAccessContext({ host, params }: BuildInput): AccessContext {
  let urlHost: string | undefined;
  if (params.url) {
    try {
      urlHost = new URL(params.url).hostname;
    } catch {
      urlHost = undefined; // url malformado não quebra a resolução
    }
  }
  return { host, rules: params.rules, urlHost };
}
